import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  closeResult = '';

  public clientNumber:string;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
    this.clientNumber = localStorage.getItem('clientNumber');
  }

  openModal(content) {
    this.modalService.open(content);
  }

  openClientPortal() {
    window.open('https://cp.hunterwarfield.com/login');
  }
}
